import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { downloadText } from '../util/download.js';
import { toJsonl } from '../util/jsonl.js';
import { toCsv } from '../util/csv.js';

export interface ConfigRow {
  key: string;
  value: string;
  updatedAt: string;
  siteKey?: string;
}

export default function ConfigExportMenu(props: { rows: ConfigRow[]; filename?: string }) {
  const { rows, filename = 'config-export' } = props;

  const items: MenuProps['items'] = [
    {
      key: 'json',
      label: 'Export JSON (current view)',
      onClick: () =>
        downloadText(`${filename}.json`, JSON.stringify(rows, null, 2), 'application/json'),
    },
    {
      key: 'jsonl',
      label: 'Export JSONL (current view)',
      onClick: () => downloadText(`${filename}.jsonl`, toJsonl(rows), 'application/x-ndjson'),
    },
    {
      key: 'csv',
      label: 'Export CSV (current view)',
      onClick: () =>
        downloadText(
          `${filename}.csv`,
          toCsv(rows as unknown as Record<string, unknown>[], [
            'siteKey',
            'key',
            'value',
            'updatedAt',
          ]),
          'text/csv',
        ),
    },
  ];

  return (
    <Dropdown.Button menu={{ items }} type="default">
      Export
    </Dropdown.Button>
  );
}
